exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/var/www/www.taburi.ro/releases/98/src"]}!./src/components/accountSettings/css/index.scss
// module id = 323
// module chunks = 0